import { useState } from "react";
import {
    Paper, Stack, Typography, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TablePagination, Button, Chip
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import useWithdrawal from "../../../hooks/useWithdrawal";
import { markItemSold } from "../../../api/kiz";
import DownloadExcelButton from "../../../components/layout/DownloadExcelButton";
import { fetchAllWithdrawal } from "../../../api/withdrawal";
import { exportToExcel } from "../../../utils/exportToExcel";
import DashboardLayout from "../../../components/layout/DashboardLayout";
import { setMarket } from "../../../redux/slices/uiSlice";

export default function KizWithdrawalPage() {
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [reloadToken, setReloadToken] = useState(0);
    const { rows, total, loading } = useWithdrawal({ page, pageSize, reloadToken });
    const dispatch = useDispatch();
    const market = useSelector((s) => s.ui.market);

    async function onMarkSold(row) {
        try {
            await markItemSold(row.documentId);
            setReloadToken((x) => x + 1); // перегрузить список
        } catch (e) {
            console.error("Не удалось пометить как продан:", e);
            alert("Не удалось пометить как продан");
        }
    }

    async function exportWithdrawal() {
        const allRows = await fetchAllWithdrawal({ pageSize: 200 });

        const rowsForExcel = allRows.flatMap((posting) => {
            const items = posting.items && posting.items.length > 0 ? posting.items : [posting];

            return items.map((item) => ({
                Posting: posting.posting_number,
                Маркет: (posting.market || "").toUpperCase(),
                SKU: item.sku || posting.sku || "",
                Offer: item.offer_id || posting.offer_id || "",
                Название: item.name || posting.name || "",
                "Кол-во": item.quantity || posting.quantity || "",
                КИЗ: item.kiz_code || posting.kiz_code || "",
                "Статус вывода": (item.withdrawal_status || posting.withdrawal_status) === "sold" ? "Продан" : "На балансе",
            }));
        });

        exportToExcel({
            rows: rowsForExcel,
            sheetName: "КИЗ",
            fileName: "kiz_withdrawal",
        });
    }

    return (
        <DashboardLayout
            market={market}
            onSelectMarket={(v) => dispatch(setMarket(v))}
        >
            <Stack spacing={2}>
                <Paper sx={{ p: 2 }}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
                        <Typography variant="h6">КИЗ для вывода из оборота</Typography>
                        <Stack direction="row" spacing={1}>
                            <DownloadExcelButton onExport={exportWithdrawal} disabled={loading} />
                            <Button size="small" onClick={() => setReloadToken((x) => x + 1)} disabled={loading}>
                                Обновить
                            </Button>
                        </Stack>
                    </Stack>

                    <TableContainer sx={{ maxHeight: 560 }}>
                        <Table stickyHeader size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Posting</TableCell>
                                    <TableCell>Маркет</TableCell>
                                    <TableCell>SKU</TableCell>
                                    <TableCell>Offer</TableCell>
                                    <TableCell>Название</TableCell>
                                    <TableCell align="right">Кол-во</TableCell>
                                    <TableCell>КИЗ</TableCell>
                                    <TableCell>Статус</TableCell>
                                    <TableCell align="right">Действие</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.map((r) => (
                                    <TableRow key={r.id} hover>
                                        <TableCell>{r.posting_number}</TableCell>
                                        <TableCell>{(r.market || "").toUpperCase()}</TableCell>
                                        <TableCell>{r.sku}</TableCell>
                                        <TableCell>{r.offer_id}</TableCell>
                                        <TableCell>{r.name}</TableCell>
                                        <TableCell align="right">{r.quantity}</TableCell>
                                        <TableCell>
                                            <code style={{ fontSize: 12 }}>{r.kiz_code}</code>
                                        </TableCell>
                                        <TableCell>
                                            {r.withdrawal_status === "on_balance" ? (
                                                <Chip label="На нашем балансе" size="small" />
                                            ) : (
                                                <Chip label="Продан" color="success" size="small" />
                                            )}
                                        </TableCell>
                                        <TableCell align="right">
                                            <Button
                                                size="small"
                                                variant="contained"
                                                disabled={r.withdrawal_status === "sold"}
                                                onClick={() => onMarkSold(r)}
                                            >
                                                Отметить как продан
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}

                                {rows.length === 0 && !loading && (
                                    <TableRow>
                                        <TableCell colSpan={9} align="center" sx={{ py: 3 }}>
                                            Нет позиций для вывода из оборота
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <TablePagination
                        component="div"
                        count={total}
                        page={page}
                        onPageChange={(_, p) => setPage(p)}
                        rowsPerPage={pageSize}
                        onRowsPerPageChange={(e) => { setPageSize(parseInt(e.target.value, 10)); setPage(0); }}
                        rowsPerPageOptions={[10, 20, 50]}
                    />
                </Paper>
            </Stack>
        </DashboardLayout>
    );
}
